import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';

const state = {
  question_types: null,
};

const getters = {
  async question_types(state) {
    let question_types = state.question_types;
    if (!question_types) question_types = JSON.parse(localStorage.getItem('question_types'));
    return question_types;
  },
};

const mutations = {
  setQuestionTypes(state, data) {
    state.question_types = data;
    localStorage.setItem('question_types', JSON.stringify(data));
  },
};

const actions = {
  async retrieveQuestionTypes({ commit, getters }) {
    let question_types = await getters.question_types;
    if (!question_types) question_types = await QuestionTypeController.index();
    await commit('setQuestionTypes', question_types);
    return question_types;
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
